import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Las páginas legales son HTML estático (public/*.html), una sola fuente con
// fixo.com.ar. Un clic interno no pasa por el servidor: esta ruta lo manda ahí.
// La marca evita el bucle: si el servidor no tiene el archivo devuelve el index,
// y sin ella la app recargaría para siempre.
export default function PaginaEstatica() {
  const { pathname, search } = useLocation();
  const yaFue = new URLSearchParams(search).has('estatica');

  useEffect(() => {
    if (!yaFue) window.location.replace(`${pathname}?estatica=1`);
  }, [pathname, yaFue]);

  if (!yaFue) return null;
  return (
    <p style={{ padding: 24, fontFamily: 'Montserrat, sans-serif' }}>
      No pudimos abrir esta página. Escribinos a legal@fixo.com.ar.
    </p>
  );
}
